export const gitCommit = '83c38366'
